import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Vision from "./components/vision/Vision";
import WhatWeDo from "./components/whatwedo/WhatWeDo";
import Philosophy from "./components/Philosophy";
import ContactCTA from "./components/ContactCTA";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

const Landing = () => (
  <div className="min-h-screen bg-white text-neutral-900 font-[Inter]">
    <Navbar />
    <main>
      <Hero />
      <About />
      <Vision />
      <WhatWeDo />
      <Philosophy />
    </main>
    <ContactCTA />
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
